export default __webpack_public_path__ + "static/media/xmas-slide1-mobile.d2cf20a0.jpg";